import Container from 'app/components/common/Container';

import JourneyCard from './JourneyCard';

const style = {
  section: {
    alignItems: 'flex-end',
    backgroundColor: 'rgba(249, 249, 249, 0.75)',
    padding: '20px 0',
    maxWidth: '100vw',
    overflowX: 'auto',
  },
};

export default function Journey({
  data = {},
  background,
  backgroundPosition = 'center',
}) {
  return (
    <div className={`${background} ${backgroundPosition} bg-no-repeat`}>
      <Container className="text-center">
        <h6
          className={`${data?.h1_black && 'mb-[30px]'} font-[800] xl:text-[50px] md:text-[32px] text-[26px] title_hd leading-tight`}
        >
          {data?.h1_black}
        </h6>
        <section className={`flex`} style={style.section}>
          {data?.Our_Journey_content?.length > 0 &&
            data?.Our_Journey_content?.map((cardData, index) => (
              <JourneyCard
                key={index}
                data={cardData}
                position={48 * index}
                index={index}
                max={data?.Our_Journey_content?.length}
              />
            ))}
        </section>
      </Container>
    </div>
  );
}
